import UtilService from "../services/util.service";

export default {
  name: "toCurrency",
  fn: value => {
    return UtilService.toCurrency(value);
  }
};
